import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import PracticeArea from "@/pages/PracticeArea";
import { PRACTICE_AREAS } from "@/data/practiceAreas";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          {PRACTICE_AREAS.map((area) => (
            <Route
              key={area.slug}
              path={`/${area.slug}`}
              element={<PracticeArea slug={area.slug} />}
            />
          ))}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
